import ManageCard from "@components/ManageCard/ManageCard";
import styles from "./Manage.module.css";
import { useNavigate } from "react-router";

const ManagePage = () => {
  const navigate = useNavigate();

  const handleManageDoctor = () => {
    navigate("/managedoctor");
  };
  const handleManagePatient = () => {
    navigate("/managepatient");
  };
  const handleManagePrice = () => {
    navigate("/manageprice");
  }
  const handleManagePostPay = () => {
    navigate("/managepostpay");
  }
  const handleTicketSupport = () => {
    navigate("/ticketsupport");
  }

  return (
    <>
      <div className={styles.Wrapper}>
        <div className={styles.cardWrap}>
          <ManageCard heading={"Manage Doctor"} onClick={handleManageDoctor} />
          <ManageCard heading={"Manage Patient"} onClick={handleManagePatient} />
          <ManageCard heading={"Manage Price"} onClick={handleManagePrice} />
        </div>
        <div className={styles.cardWrap}>
          <ManageCard heading={"Manage Post Pay"} onClick={handleManagePostPay} />
          <ManageCard heading={"Ticket Support"} onClick={handleTicketSupport} />
        </div>
      </div>
    </> 
  );
};

export default ManagePage;
